<template>
  <svg width="42" height="42" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <filter x="-30%" y="-23.3%" width="160%" height="160%" filterUnits="objectBoundingBox" id="a">
        <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1" />
        <feOffset dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
        <feColorMatrix
          values="0 0 0 0 0.356862745 0 0 0 0 0.356862745 0 0 0 0 0.356862745 0 0 0 0.25 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <circle id="b" cx="15" cy="15" r="15" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(6 4)">
        <use fill="#000" filter="url(#a)" xlink:href="#b" />
        <circle stroke="#FFF" stroke-width="2" fill="#9F8054" cx="15" cy="15" r="16" />
      </g>
      <path
        d="M19.301 14.688a.564.564 0 0 1 .554.323l2.164 4.611A6.058 6.058 0 0 1 20.35 26.9a1.1 1.1 0 0 1-.478.225 6.059 6.059 0 0 1-6.664-3.37l-2.152-4.587a.602.602 0 0 1 .114-.676c.551-.566 1.686-1.516 3.773-2.495 2.11-.99 3.576-1.25 4.357-1.309Zm.948 7.003a.537.537 0 0 0-.688.323 2.3 2.3 0 0 1-2.942 1.38.537.537 0 1 0-.365 1.01 3.379 3.379 0 0 0 4.318-2.026.538.538 0 0 0-.323-.687ZM24.135 12c2.305 0 3.735.378 4.475.656.235.088.39.313.39.564v5.067c0 2.8-1.914 5.217-4.6 5.881a1.105 1.105 0 0 1-.532 0 6.092 6.092 0 0 1-.443-.129 7.126 7.126 0 0 0 .03-3.575 2.3 2.3 0 0 1 2.304.569.535.535 0 0 0 .783-.024.548.548 0 0 0-.037-.75 3.375 3.375 0 0 0-3.39-.815 6.938 6.938 0 0 0-.123-.278l-1.027-2.189.091.002c.477 0 .925-.185 1.261-.522a.538.538 0 0 0-.098-.838.545.545 0 0 0-.669.085.71.71 0 0 1-.672.179.718.718 0 0 1-.327-.19.535.535 0 0 0-.254-.139l-.763-1.628a.537.537 0 0 0-.4-.302c-.03-.005-.321-.049-.865-.012v-.392c0-.25.155-.476.39-.564.74-.278 2.17-.656 4.476-.656Zm-8.177 8.082a1.772 1.772 0 0 0-1.364.063c-.43.202-.757.56-.92 1.008a.537.537 0 1 0 1.011.365.704.704 0 0 1 .366-.4.704.704 0 0 1 .542-.025.538.538 0 0 0 .365-1.011Zm3.996-1.875a1.785 1.785 0 0 0-2.283 1.071.537.537 0 1 0 1.01.365.71.71 0 0 1 .908-.425.537.537 0 1 0 .365-1.01Zm6.016-2.51a.537.537 0 0 0-.76.76c.336.337.784.522 1.26.522.477 0 .925-.185 1.261-.522a.537.537 0 1 0-.76-.76.704.704 0 0 1-.5.208.704.704 0 0 1-.501-.208Z"
        fill="#FFF"
        fill-rule="nonzero"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconPoiEntertainment',
};
</script>

<style></style>
